import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementJaLocale from 'element-ui/lib/locale/lang/ja'
import zhLocale from './zh'
import jaLocale from './ja'

const LangCookie = 'yfax-lang'

Vue.use(VueI18n)

const messages = {
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
  ja: {
    ...jaLocale,
    ...elementJaLocale
  }
}

var lang = Cookies.get(LangCookie)
if (lang == undefined) {
  lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
  lang = lang.substr(0, 2);//截取lang前2位字符
  Cookies.set(LangCookie, lang);
}

const i18n = new VueI18n({
  locale: lang == 'ja' ? 'ja' : 'zh',
  messages
})

export default i18n
export function changeLang (command) {
  lang = command
  i18n.locale = lang == 'ja' ? 'ja' : 'zh'
  Cookies.set(LangCookie, lang);
}

export function getLang () {
  return lang
}



// WEBPACK FOOTER //
// ./src/lang/index.js